import { ReactElement, useMemo, useCallback } from 'react';

import {
  TrackingInTransitDeliveriesListProps,
  TrackingInTransitDeliveriesItemBase,
} from './types';
import TrackingInTransitDeliveriesItem from './Item';
import { TrackingInTransitDeliveriesListContainer } from './styles';

const MAX_PERCENTAGE = 100;

const TrackingInTransitDeliveriesList = <ED extends Record<string, unknown>>({
  data,
  onClickItem,
}: TrackingInTransitDeliveriesListProps<ED>): ReactElement => {
  const maxTotalValue = useMemo(
    () => Math.max(...data.map((item) => item.totalCount)),
    [data],
  );

  const getProgressMaxWidth = useCallback(
    (item: TrackingInTransitDeliveriesItemBase<ED>) => {
      const percentageValue =
        ((maxTotalValue - item.totalCount) / maxTotalValue) * MAX_PERCENTAGE;

      const totalPercentageValue = MAX_PERCENTAGE - percentageValue;

      return Math.round(totalPercentageValue * MAX_PERCENTAGE) / MAX_PERCENTAGE;
    },
    [maxTotalValue],
  );

  return (
    <TrackingInTransitDeliveriesListContainer>
      {data.map((item, itemIndex) => (
        <TrackingInTransitDeliveriesItem
          key={`tracking-in-transit-deliveries-item-${itemIndex}`}
          {...item}
          onClick={() => onClickItem(item.extraData as ED)}
          progressMaxWidth={`${getProgressMaxWidth(item)}%`}
        />
      ))}
    </TrackingInTransitDeliveriesListContainer>
  );
};

export default TrackingInTransitDeliveriesList;
